// extracted by mini-css-extract-plugin
export default {"chevron":"Collapse_chevron_wgRl2","container":"Collapse_container_tmJ3l","label":"Collapse_label_lhWDp","isCollapsed":"Collapse_isCollapsed_I7Jf5"};